import { render, staticRenderFns } from "./MainBannerEdit.vue?vue&type=template&id=b6b4c416&scoped=true&"
import script from "./MainBannerEdit.vue?vue&type=script&lang=ts&"
export * from "./MainBannerEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MainBannerEdit.vue?vue&type=style&index=0&id=b6b4c416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b4c416",
  null
  
)

export default component.exports